module.exports = __webpack_public_path__ + "img/amx-20.c9ad0b5d.webp";